export default defineNuxtRouteMiddleware((to, from) => {
    if (import.meta.server) return
    // skip middleware on client side entirely
    // if (import.meta.client) return
    // or only skip middleware on initial client load
    const nuxtApp = useNuxtApp()
    if (import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered) return

    const authAbilities = useState<string[] | null>('authAbilities', () => null).value

    if(
        ((to.fullPath.startsWith('/admin', 0) || to.fullPath.startsWith('/user', 0)) && authAbilities == null) ||
        (to.fullPath.startsWith('/user', 0) && !authAbilities?.includes("user"))
    ) {
        return '/';
    }

    if(to.fullPath.startsWith('/admin')) {
        if(!authAbilities?.includes('admin') && !authAbilities?.includes("moder") && !authAbilities?.includes("editor")) {
            return  '/admin'
        }
    }
})